<template>
  <div v-if="formData" class="fin-form solid-table">
    <div class="fin-form-content transtant-input">
      <el-form
        size="mini"
        ref="form"
        :model="formData"
        label-suffix="："
        label-width="350px"
        :rules="rules"
      >
        <el-collapse v-model="collapseModel">
          <el-collapse-item title="施工辅助工程" name="assist">
            <el-form-item
              label="施工供电工程单价（元/MW）"
              prop="powerProjectPrice"
              ref="powerProjectPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.powerProjectPrice"
                :fee="getFee('powerProjectPrice')"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="施工供水工程单价（元/MW）"
              prop="waterProjectPrice"
              ref="waterProjectPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.waterProjectPrice"
                :fee="getFee('waterProjectPrice')"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="其他施工辅助工程单价（元/MW）"
              prop="auxiliaryProjectPrice"
              ref="auxiliaryProjectPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.auxiliaryProjectPrice"
                :fee="getFee('auxiliaryProjectPrice')"
              ></fee-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="设备及安装工程" name="device">
            <el-divider content-position="left">
              发电场设备及安装工程
            </el-divider>
            <el-form-item
              label="风电机组单价（元/kW）"
              prop="installProjectTurbinePrice"
              ref="installProjectTurbinePrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectTurbinePrice"
                :fee="getFee('installProjectTurbinePrice')"
                title="设备费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="风电机组安装费用系数（%）"
              prop="installProjectTurbineCoefficient"
              ref="installProjectTurbineCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectTurbineCoefficient"
                :fee="getFee('installProjectTurbineCoefficient')"
                title="安装费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="塔筒单价（万元/台）"
              prop="installProjectTowerBarrelPrice"
              ref="installProjectTowerBarrelPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectTowerBarrelPrice"
                :fee="getFee('installProjectTowerBarrelPrice')"
                title="设备费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="塔筒安装费用系数（%）"
              prop="installProjectTowerBarrelCoefficient"
              ref="installProjectTowerBarrelCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectTowerBarrelCoefficient"
                :fee="getFee('installProjectTowerBarrelCoefficient')"
                title="安装费用"
              ></fee-input>
            </el-form-item>

            <el-form-item
              label="箱变单价（万元/台）"
              prop="installProjectBoxPrice"
              ref="installProjectBoxPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectBoxPrice"
                :fee="getFee('installProjectBoxPrice')"
                title="设备费用"
              ></fee-input>
            </el-form-item>

            <el-form-item
              label="箱变安装费用系数（%）"
              prop="installProjectBoxCoefficient"
              ref="installProjectBoxCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectBoxCoefficient"
                :fee="getFee('installProjectBoxCoefficient')"
                title="安装费用"
              ></fee-input>
            </el-form-item>

            <el-form-item
              label="集电线路（万元/km）"
              prop="installProjectLinePrice"
              ref="installProjectLinePrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectLinePrice"
                :fee="getFee('installProjectLinePrice')"
                title="设备费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="集电线路费用系数（%）"
              prop="installProjectLineCoefficient"
              ref="installProjectLineCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectLineCoefficient"
                :fee="getFee('installProjectLineCoefficient')"
                title="安装费用"
              ></fee-input>
            </el-form-item>

            <el-divider content-position="left">
              升压变电站设备及安装工程
            </el-divider>
            <el-form-item
              label="升压站单价（元/kW）"
              prop="installProjectBoosterPrice"
              ref="installProjectBoosterPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectBoosterPrice"
                :fee="getFee('installProjectBoosterPrice')"
                title="设备费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="升压站安装费用系数（%）"
              prop="installProjectBoosterCoefficient"
              ref="installProjectBoosterCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectBoosterCoefficient"
                :fee="getFee('installProjectBoosterCoefficient')"
                title="安装费用"
              ></fee-input>
            </el-form-item>

            <el-divider content-position="left">
              控制保护设备及安装工程
            </el-divider>
            <el-form-item
              label="控制保护设备单价（元/kW）"
              prop="installProjectProtectionPrice"
              ref="installProjectProtectionPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectProtectionPrice"
                :fee="getFee('installProjectProtectionPrice')"
                title="设备费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="控制保护设备安装费用系数（%）"
              prop="installProjectProtectionCoefficient"
              ref="installProjectProtectionCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectProtectionCoefficient"
                :fee="getFee('installProjectProtectionCoefficient')"
                title="安装费用"
              ></fee-input>
            </el-form-item>

            <el-divider content-position="left">
              其他设备及安装工程
            </el-divider>
            <el-form-item
              label="其他设备单价（元/kW）"
              prop="installProjectOtherPrice"
              ref="installProjectOtherPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectOtherPrice"
                :fee="getFee('installProjectOtherPrice')"
                title="设备费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="其他设备安装费用系数（%）"
              prop="installProjectOtherCoefficient"
              ref="installProjectOtherCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.installProjectOtherCoefficient"
                :fee="getFee('installProjectOtherCoefficient')"
                title="安装费用"
              ></fee-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="建筑工程" name="project">
            <el-form-item
              label="发电厂工程单价（元/kW）"
              prop="windfarmProjectPrice"
              ref="windfarmProjectPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.windfarmProjectPrice"
                :fee="getFee('windfarmProjectPrice')"
                title="发电工程费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="升压变电工程单价（元/kW）"
              prop="boosterProjectPrice"
              ref="boosterProjectPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.boosterProjectPrice"
                :fee="getFee('boosterProjectPrice')"
                title="升压变电费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="房屋面积（m2）"
              prop="houseArea"
              ref="houseArea"
            >
              <el-input
                v-if="backend"
                placeholder="请输入"
                v-model="formData.houseArea"
              ></el-input>
              <span v-else>{{ data.houseArea }}</span>
            </el-form-item>
            <el-form-item
              label="单价（元/m2）"
              prop="housebuildersProjectPrice"
              ref="housebuildersProjectPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.housebuildersProjectPrice"
                :fee="getFee('housebuildersProjectPrice')"
                title="房屋建筑费用"
              ></fee-input>
            </el-form-item>

            <el-form-item
              label="场内交通工程单价（万元/km）"
              prop="trafficProjectPrice"
              ref="trafficProjectPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.trafficProjectPrice"
                :fee="getFee('trafficProjectPrice')"
                title="场内交通费用"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="其他工程单价（元/kW）"
              prop="otherProjectPrice"
              ref="otherProjectPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.otherProjectPrice"
                :fee="getFee('otherProjectPrice')"
                title="其他工程费用"
              ></fee-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="其他费用" name="other">
            <el-divider content-position="left">
              项目建设用地费
            </el-divider>
            <el-form-item
              label="土地征用单价（元/亩/年）"
              prop="landAcquisitionPrice"
              ref="landAcquisitionPrice"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.landAcquisitionPrice"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="征地面积（亩）"
              prop="boosterProjectPrice"
              ref="boosterProjectPrice"
            >
              <el-input
                v-if="backend"
                placeholder="请输入"
                v-model="formData.landAcquisitionArea"
              ></el-input>
              <span v-else>{{ data.landAcquisitionArea }}</span>
            </el-form-item>
            <el-form-item
              label="项目周期（年）"
              prop="landAcquisitionProjectCycle"
              ref="landAcquisitionProjectCycle"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.landAcquisitionProjectCycle"
                :fee="getFee('landAcquisitionProjectCycle')"
                title="土地征用费用"
                :inline="false"
              ></fee-input>
            </el-form-item>

            <el-form-item
              label="临时用地单价（元/亩/年）"
              prop="temporaryLandRentalPrice"
              ref="temporaryLandRentalPrice"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.temporaryLandRentalPrice"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="临时用地面积（亩）"
              prop="trafficProjectPrice"
              ref="trafficProjectPrice"
            >
              <el-input
                v-if="backend"
                placeholder="请输入"
                v-model="formData.temporaryLandArea"
              ></el-input>
              <span v-else>{{ data.temporaryLandArea }}</span>
            </el-form-item>
            <el-form-item
              label="用地周期（年）"
              prop="temporaryLandRentalCycle"
              ref="temporaryLandRentalCycle"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.temporaryLandRentalCycle"
                :fee="getFee('temporaryLandRentalCycle')"
                title="临时用地费用"
                :inline="false"
              ></fee-input>
            </el-form-item>

            <el-form-item
              label="补偿面积（亩）"
              prop="migrationCompensationArea"
              ref="migrationCompensationArea"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.migrationCompensationArea"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="补偿用地单价（元/亩）"
              prop="migrationCompensationPrice"
              ref="migrationCompensationPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.migrationCompensationPrice"
                :fee="getFee('migrationCompensationPrice')"
                title="迁移补偿费用"
                :inline="false"
              ></fee-input>
            </el-form-item>

            <el-form-item
              label="余物清理系数（%）"
              prop="residualCleaningCoefficient"
              ref="residualCleaningCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.residualCleaningCoefficient"
                :fee="getFee('residualCleaningCoefficient')"
                title="余物清理费用"
                :inline="false"
              ></fee-input>
            </el-form-item>

            <el-divider content-position="left">
              项目建设管理费
            </el-divider>
            <el-form-item
              label="工程前期费用系数（%）"
              prop="projectPrePaymentCoefficient"
              ref="projectPrePaymentCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.projectPrePaymentCoefficient"
                :fee="getFee('projectPrePaymentCoefficient')"
                title="工程前期费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="工程建设管理费用系数（%）"
              prop="projectConstructionManagementCoefficient"
              ref="projectConstructionManagementCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.projectConstructionManagementCoefficient"
                :fee="getFee('projectConstructionManagementCoefficient')"
                title="工程建设管理费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="工程建设监理费用系数（%）"
              prop="projectConstructionSupervisionCoefficient"
              ref="projectConstructionSupervisionCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.projectConstructionSupervisionCoefficient"
                :fee="getFee('projectConstructionSupervisionCoefficient')"
                title="工程建设监理费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="项目咨询服务费用系数（%）"
              prop="projectConsultingServiceCoefficient"
              ref="projectConsultingServiceCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.projectConsultingServiceCoefficient"
                :fee="getFee('projectConsultingServiceCoefficient')"
                title="项目咨询服务费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="项目技术经济评审费用系数（%）"
              prop="projectTechnoEconomicsAssessCoefficient"
              ref="projectTechnoEconomicsAssessCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.projectTechnoEconomicsAssessCoefficient"
                :fee="getFee('projectTechnoEconomicsAssessCoefficient')"
                title="项目技术经济评审费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="项目验收费用系数（%）"
              prop="projectInspectionCoefficient"
              ref="projectInspectionCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.projectInspectionCoefficient"
                :fee="getFee('projectInspectionCoefficient')"
                title="项目验收费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="工程保险费用系数（%） "
              prop="projectInsuranceCoefficient"
              ref="projectInsuranceCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.projectInsuranceCoefficient"
                :fee="getFee('projectInsuranceCoefficient')"
                title="工程保险费用"
                :inline="false"
              ></fee-input>
            </el-form-item>

            <el-divider content-position="left">
              生产准备费
            </el-divider>
            <el-form-item
              label="人员培训及提前进场费用系数（%）"
              prop="personnelTrainEntranceCoefficient"
              ref="personnelTrainEntranceCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.personnelTrainEntranceCoefficient"
                :fee="getFee('personnelTrainEntranceCoefficient')"
                title="人员培训及提前进场费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="管理用具购置费建安费用系数（%） "
              prop="managementEquipmentPurchaseCostCoefficient"
              ref="managementEquipmentPurchaseCostCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.managementEquipmentPurchaseCostCoefficient"
                :fee="getFee('managementEquipmentPurchaseCostCoefficient')"
                title="管理用具购置费建安费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="工器具及生产家具购置费用系数（%）"
              prop="utensilProductionFurniturePurchaseCoefficient"
              ref="utensilProductionFurniturePurchaseCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.utensilProductionFurniturePurchaseCoefficient"
                :fee="getFee('utensilProductionFurniturePurchaseCoefficient')"
                title="工器具及生产家具购置费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="备品备件购置费用系数（%）"
              prop="repairPiecePurchaseCoefficient"
              ref="repairPiecePurchaseCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.repairPiecePurchaseCoefficient"
                :fee="getFee('repairPiecePurchaseCoefficient')"
                title="备品备件购置费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="联合试运转费用系数（%）"
              prop="uniteRunningCoefficient"
              ref="uniteRunningCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.uniteRunningCoefficient"
                :fee="getFee('uniteRunningCoefficient')"
                title="联合试运转费用"
                :inline="false"
              ></fee-input>
            </el-form-item>

            <el-divider content-position="left">
              勘察设计费
            </el-divider>
            <el-form-item
              label="勘察费用单价（元/kW）"
              prop="surveyPrice"
              ref="surveyPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.surveyPrice"
                :fee="getFee('surveyPrice')"
                title="勘察费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="设计费用单价（元/kW）"
              prop="designPrice"
              ref="designPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.designPrice"
                :fee="getFee('designPrice')"
                title="设计费用"
                :inline="false"
              ></fee-input>
            </el-form-item>
            <el-form-item
              label="其他费用单价（元/kW）"
              prop="otherPrice"
              ref="otherPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.otherPrice"
                :fee="getFee('otherPrice')"
                title="其他费用"
                :inline="false"
              ></fee-input>
            </el-form-item>

            <el-divider content-position="left">
              其他税费
            </el-divider>
            <el-form-item
              label="其他税费单价（元/kW）"
              prop="otherTaxesPrice"
              ref="otherTaxesPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.otherTaxesPrice"
                :fee="getFee('otherTaxesPrice')"
                title="其他税费"
              ></fee-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="基本预备费用" name="basic">
            <el-form-item
              label="基本预备费用系数（%）"
              prop="basicReserveCoefficient"
              ref="basicReserveCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.basicReserveCoefficient"
                :fee="getFee('basicReserveCoefficient')"
              ></fee-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="价差预备费用" name="diff">
            <el-form-item
              label="价差预备费用系数（%）"
              prop="priceDifferenceReserveCoefficient"
              ref="priceDifferenceReserveCoefficient"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.priceDifferenceReserveCoefficient"
                :fee="getFee('priceDifferenceReserveCoefficient')"
              ></fee-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="建设期利息" name="interest">
            <el-form-item
              label="建设周期（年）"
              prop="constructionPeriod"
              ref="constructionPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.constructionPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="贷款利率（%）"
              prop="lendingRate"
              ref="lendingRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.lendingRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="资本金比例（%）"
              prop="capitalRatio"
              ref="capitalRatio"
            >
              <fee-input
                placeholder="请输入"
                title="利息"
                v-model="formData.capitalRatio"
                :fee="getFee('capitalRatio')"
              ></fee-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="送出工程投资" name="outProject">
            <el-form-item
              label="送出线路长度（km）"
              prop="sendOutLineLength"
              ref="sendOutLineLength"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.sendOutLineLength"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="送出线路单价（万元/km）"
              prop="sendOutLineLengthPrice"
              ref="sendOutLineLengthPrice"
            >
              <fee-input
                placeholder="请输入"
                v-model="formData.sendOutLineLengthPrice"
                :fee="getFee('sendOutLineLengthPrice')"
                :inline="false"
              ></fee-input>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div class="bottom-tool">
      <el-button @click="reset">重置</el-button>
      <el-button type="primary" @click="save">{{
        backend ? '保存' : '保存并计算'
      }}</el-button>
    </div>
  </div>
  <div v-else>
    <div class="fin-form empty-form">暂无数据</div>
  </div>
</template>

<script>
import { number } from '@/utils/rules';
import FeeInput from './fee-input';
import { FeeCompute } from './fee-compute';

const rules = {
  double: [
    number({
      min: 0,
      max: 1000000000000000,
      equal: { min: true, max: true },
      precision: 2
    })
  ],
  int: [
    number({
      min: 0,
      max: 1000000000,
      equal: { min: true, max: true },
      precision: 0
    })
  ],
  percentage: [
    number({
      min: 0,
      max: 100,
      equal: { min: true, max: true },
      precision: 2
    })
  ]
};

export default {
  components: {
    FeeInput
  },
  props: {
    formData: {
      type: Object,
      default: () => null
    },
    data: {
      type: Object,
      default: () => null
    },
    backend: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      collapseModel: [
        'assist',
        'device',
        'project',
        'other',
        'basic',
        'diff',
        'interest',
        'outProject'
      ],
      rules: {
        powerProjectPrice: rules.double,
        waterProjectPrice: rules.double,
        auxiliaryProjectPrice: rules.double,
        installProjectTurbinePrice: rules.double,
        installProjectTurbineCoefficient: rules.double,
        installProjectTowerBarrelPrice: rules.double,
        installProjectTowerBarrelCoefficient: rules.double,
        installProjectBoxPrice: rules.double,
        installProjectBoxCoefficient: rules.double,
        installProjectLinePrice: rules.double,
        installProjectLineCoefficient: rules.double,
        installProjectBoosterPrice: rules.double,
        installProjectBoosterCoefficient: rules.double,
        installProjectProtectionPrice: rules.double,
        installProjectProtectionCoefficient: rules.double,
        installProjectOtherPrice: rules.double,
        installProjectOtherCoefficient: rules.double,
        windfarmProjectPrice: rules.double,
        boosterProjectPrice: rules.double,
        housebuildersProjectPrice: rules.double,
        trafficProjectPrice: rules.double,
        otherProjectPrice: rules.double,
        landAcquisitionPrice: rules.double,
        landAcquisitionProjectCycle: rules.int,
        temporaryLandRentalPrice: rules.double,
        temporaryLandRentalCycle: rules.int,
        migrationCompensationArea: rules.double,
        migrationCompensationPrice: rules.double,
        residualCleaningCoefficient: rules.double,
        projectPrePaymentCoefficient: rules.double,
        projectConstructionManagementCoefficient: rules.double,
        projectConstructionSupervisionCoefficient: rules.double,
        projectConsultingServiceCoefficient: rules.double,
        projectTechnoEconomicsAssessCoefficient: rules.double,
        projectInspectionCoefficient: rules.double,
        projectInsuranceCoefficient: rules.double,
        personnelTrainEntranceCoefficient: rules.double,
        managementEquipmentPurchaseCostCoefficient: rules.double,
        utensilProductionFurniturePurchaseCoefficient: rules.double,
        repairPiecePurchaseCoefficient: rules.double,
        uniteRunningCoefficient: rules.double,
        surveyPrice: rules.double,
        designPrice: rules.double,
        otherPrice: rules.double,
        otherTaxesPrice: rules.double,
        basicReserveCoefficient: rules.double,
        priceDifferenceReserveCoefficient: rules.double,
        constructionPeriod: rules.int,
        sendOutLineLength: rules.double,
        sendOutLineLengthPrice: rules.double,
        lendingRate: rules.double,
        capitalRatio: rules.double
      }
    };
  },
  methods: {
    getFee(key) {
      if (!FeeCompute[key]) {
        console.error('unsupport key', key);
        return '';
      }
      return FeeCompute[key].getFee(this);
    },
    changeStaticTotalInvestment(value) {
      this.formData.staticTotalInvestment = value;
    },
    save() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.$emit('save');
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            if (i.indexOf('.') !== -1) {
              dom = this.$refs[i.split('.')[0]];
            }
            if (
              Object.prototype.toString.call(dom) !== '[object Object]' &&
              dom
            ) {
              //这里是针对遍历的情况（多个输入框），取值为数组
              dom = dom[0];
            } //第一种方法（包含动画效果）
            if (!dom) continue;
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
            break; //因为我们只需要检测一项,所以就可以跳出循环了
          }
          console.error(object);
        }
      });
    },
    reset() {
      this.$emit('reset');
    }
  }
};
</script>
<style lang="less" scoped>
.fin-form {
  background: #fff;

  /deep/.el-input {
    width: 300px;
  }

  /deep/.el-collapse-item__header {
    background: #c8e0f5;
  }

  /deep/.el-collapse {
    .el-input-group__append {
      border: none;
      border-bottom: 1px solid #fff;
    }

    .el-collapse-item__header,
    .el-collapse-item__wrap {
      padding-left: 16px;
    }

    .el-collapse-item__header {
      height: 30px;
    }
  }

  .bottom-tool {
    text-align: center;
    padding: 10px;
    background: #fff;
  }
}
</style>
